import { connect } from 'react-redux'
import League from '../components/league'

const mapStateToProps = state => ({...state.league})

const mapDispatchToProps = dispatch => ({
  changeTab: payload => dispatch({type: 'LEAGUE.CHANGE_TAB', payload}),
  updateData: payload => dispatch({type: 'LEAGUE.UPDATE_DATA', payload}),
  addTeam: payload => dispatch({type: 'LEAGUE.ADD_TEAM', payload}),
  deleteTeam: payload => dispatch({type: 'LEAGUE.DELETE_TEAM', payload}),
  updateTeam: payload => dispatch({type: 'LEAGUE.UPDATE_TEAM', payload}),
  createSchedule: payload => dispatch({type: 'LEAGUE.CREATE_SCHEDULE', payload}),
  createGames: payload => dispatch({type: 'LEAGUE.CREATE_GAMES', payload}),
  updateGame: payload => dispatch({type: 'LEAGUE.UPDATE_GAME', payload}),
  closeLeague: payload => dispatch({type: 'LEAGUE.CLOSE_LEAGUE', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(League)
